module.exports = __webpack_public_path__ + "static/media/velour4E.ca369db8.jpg";